import { defineSlotRecipe } from '@chakra-ui/react';
import { BorderWidths, Colors, Space } from '../../types';

export const listSlotRecipe = defineSlotRecipe({
  slots: ['root', 'item', 'indicator'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--list-gap)',
      '& :where(ul, ol)': {
        marginTop: 'var(--list-gap)',
      },
    },
    item: {
      whiteSpace: 'normal',
      display: 'list-item',
    },
    indicator: {
      marginEnd: '2',
      minHeight: '1lh',
      flexShrink: 0,
      display: 'inline-block',
      verticalAlign: 'middle',
    },
  },
  variants: {
    variant: {
      contentList: {
        item: {
          paddingY: Space.LG,
          borderBottomWidth: BorderWidths.XS,
          borderColor: Colors.BORDER_DEFAULT,
        },
      },
    },
  },
});
